// eslint-disable-next-line import/prefer-default-export
export const TYPING_DEBOUNCE_TIMEOUT = 3000;
